<script>
import creationIcon from '@/assets/images/icon-creation-outline.svg'

export default {
  data() {
    return {
      chatViewStyles: {
        borderRadius: '10px',
        width: '75vw',
        paddingTop: '10px',
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        height: '100%',
      },
      submitButtonStyles: {
        submit: {
          container: {
            default: {
              paddingBottom: '12px',
              paddingRight: '12px',
            },
            hover: { backgroundColor: 'transparent' },
            click: { backgroundColor: 'transparent' },
          },
          svg: {
            content:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path></svg>',
            styles: {
              default: {
                color: '#3882f0',
                filter: 'none !important',
              },
            },
          },
        },
        stop: {
          container: {
            default: {
              paddingBottom: '11px',
            },
            hover: { backgroundColor: 'transparent' },
            click: { backgroundColor: 'transparent' },
          },
          svg: {
            content:
              '<svg width="27px" height="27px" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="stop_icon" stroke-width="0"><rect x="0" y="0" width="24.00" height="24.00" rx="12" fill="none" strokewidth="0"></rect></g><g id="stop_icon" stroke-linecap="round" stroke-linejoin="round"></g><g id="stop_icon"> <path d="M12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89472 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17294C11.99 2.82567 13.7996 3.0039 15.4442 3.68509C17.0887 4.36628 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.387 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21ZM12 4.5C10.5166 4.5 9.0666 4.93987 7.83323 5.76398C6.59986 6.58809 5.63856 7.75943 5.07091 9.12988C4.50325 10.5003 4.35473 12.0083 4.64411 13.4632C4.9335 14.918 5.64781 16.2544 6.6967 17.3033C7.7456 18.3522 9.08197 19.0665 10.5368 19.3559C11.9917 19.6453 13.4997 19.4968 14.8701 18.9291C16.2406 18.3614 17.4119 17.4001 18.236 16.1668C19.0601 14.9334 19.5 13.4834 19.5 12C19.5 10.0109 18.7098 8.10323 17.3033 6.6967C15.8968 5.29018 13.9891 4.5 12 4.5Z" fill="#000000"></path> <path d="M14.5 8H9.5C8.67157 8 8 8.67157 8 9.5V14.5C8 15.3284 8.67157 16 9.5 16H14.5C15.3284 16 16 15.3284 16 14.5V9.5C16 8.67157 15.3284 8 14.5 8Z" fill="#000000"></path> </g></svg>',
            styles: {
              default: {
                filter:
                  'brightness(0) saturate(100%) invert(92%) sepia(11%) saturate(140%) hue-rotate(175deg) brightness(102%) contrast(89%)',
              },
            },
          },
        },
      },
      customButtons: [
        {
          position: 'outside-left',
          tooltip: {
            text: this.$t('ai_features.help_center_article_tooltip'),
          },
          styles: {
            button: {
              default: {
                container: {
                  default: {
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  },
                },
                svg: {
                  styles: {
                    color: '#A0AEC0',
                  },
                  content:
                    '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" id="mdi-information-outline" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"></path></svg>',
                },
              },
            },
          },
          onClick: () => {
            window.open(this.$t('ai_features.help_center_article'), '_blank')
          },
        },
      ],
      messageStyles: {
        default: {
          user: {
            bubble: {
              backgroundColor: '#3882f0',
              padding: '10px',
              border: '1px solid #3882f0',
              fontFamily: 'Inter, sans-serif',
            },
          },
          ai: {
            bubble: {
              backgroundColor: '#ffff',
              padding: '10px',
              border: '1px solid #e2e8f0',
              color: '#4a5568',
              fontFamily: 'Inter, sans-serif',
            },
          },
        },
        loading: {
          message: {
            styles: {
              bubble: {
                backgroundColor: '#ffff',
                color: '#9cc1f8',
                padding: '12px',
                display: 'flex',
                justifyContent: 'center',
                width: '50px',
              },
            },
          },
          history: {
            small: {
              styles: {
                outerContainer: { marginBottom: '60px' },
                bubble: {
                  color: '#9cc1f8',
                  border: '5px solid',
                  height: '80px',
                  width: '80px',
                },
              },
            },
            full: {
              styles: {
                outerContainer: { marginTop: '28px' },
                bubble: {
                  color: '#9cc1f8',
                  border: '5px solid',
                  height: '80px',
                  width: '80px',
                },
              },
            },
          },
        },
        image: {
          shared: {
            media: {
              borderRadius: '10px',
              height: '200px',
              width: '200px',
            },
          },
        },
        html: {
          shared: {
            bubble: {
              backgroundColor: 'unset',
              padding: '0px',
              maxWidth: '60%',
            },
          },
        },
        error: {
          bubble: {
            color: '#f82b60',
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#f82b601f',
            borderRadius: '4px',
            fontSize: '16px',
            borderLeft: '6px solid #f82b6042',
            fontWeight: '100',
          },
        },
      },
      aiAvatarStyle: {
        src: creationIcon,
        styles: {
          avatar: {
            height: '18px',
            width: '18px',
            marginBottom: '5px',
            marginRight: '2px',
            color: '#ffff',
          },
          container: {
            height: '30px',
            width: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: `linear-gradient(
             #102046 0 0
            ) padding-box,
            conic-gradient(
              from 180deg at 50% 50%,
              #b3d3ff 0deg,
              #3882f0 152.05deg,
              #b3d3ff 360deg
            ) border-box`,
            border: '2px solid transparent',
            borderRadius: '50%',
          },
        },
      },
      textInputStyles: {
        placeholder: {
          text: this.$t('ai_features.chat_view.placeholder'),
          style: { color: '#cbd5e0', fontWeight: 'normal' },
        },
        styles: {
          container: {
            padding: '12px',
            width: '80%',
            borderRadius: '40px',
            borderWidth: '2px',
            caretColor: '#3882f0',
            background: `linear-gradient(#FFF 0 0)
              padding-box,
              conic-gradient(
                from 180deg at 50% 50%,
                #b3d3ff 0deg,
                #3882f0 152.05deg,
                #b3d3ff 360deg
              )
              border-box
            `,
          },
        },
        characterLimit: 10000,
      },
      auxiliaryStyle: `
        .loading-history-message-full-view {
          .avatar-container {
            visibility: hidden;
          }
        }

        .loading-history-message-small {
          .avatar-container {
            visibility: hidden;
          }
        }
      `,
    }
  },
}
</script>
